export interface BatchUserRemovalRequest {
  userRegistrationBranchCode: string
  processType: string
  order: string
  userType: string
  isUpdate: boolean
  rangeFromRegistration: number
  rangeFromLastLend: number
  rangeFromExpirationDate: number
  userStatus: []
  basedDate: string
  batchType: string
}

export function BatchUserRemovalRequestToJSON(
  value: BatchUserRemovalRequest
): any {
  return {
    user_registration_branch_code: value.userRegistrationBranchCode,
    process_type: value.processType,
    order: value.order,
    user_type: value.userType,
    is_update: value.isUpdate,
    range_from_registration: value.rangeFromRegistration,
    range_from_last_lend: value.rangeFromLastLend,
    range_from_expiration_date: value.rangeFromExpirationDate,
    user_status: value.userStatus,
    based_date: value.basedDate,
    batch_type: value.batchType
  }
}
